<div class="toolbar">
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="goBack()">
      <span>
        <mat-icon>keyboard_arrow_left</mat-icon>
        <label>Back</label>
      </span>
    </button>
  </span>
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="downloadTemplate()">
      <span>
        <mat-icon>download</mat-icon>
        <label>Download Template</label>
      </span>
    </button>
    @if (!readOnly()) {
      <input class="fileInput" type="file" #fileSelection id="fileSelection"
        (change)="fileChange($event);fileSelection.value=''"/>
      <label class="uploadLabel" for="fileSelection">
        <mat-icon class="size-16">upload_file</mat-icon>
        Upload Excel
      </label>
    }
  </span>
  <span class="spacer"></span>
  <span>
    <button class="primary-button" matButton="text" [disabled]="readOnly() || isBusy()" (click)="save()">
      <span>
        <mat-icon>save</mat-icon>
        <label>Save</label>
      </span>
    </button>
  </span>
</div>
<div class="filterRow">
  <span class="filterItem">
    <label class="filterLabel">Riser Group:</label>
    <select class="filterSelect" (change)="onFilterChange();" [(ngModel)]="filterRiserGroup">
      <option value="">All</option>
      @for (option of riserGroupOptions(); track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </span>
  <span class="filterItem">
    <label class="filterLabel">Building:</label>
    <select class="filterSelect" (change)="onFilterChange();" [(ngModel)]="filterBuilding">
      <option value="">All</option>
      @for (option of buildingOptions(); track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </span>
  <span class="filterItem">
    <label class="filterLabel">Riser:</label>
    <select class="filterSelect" (change)="onFilterChange();" [(ngModel)]="filterRiser">
      <option value="">All</option>
      @for (option of riserOptions(); track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </span>
  <span class="filterItem">
    <label class="filterLabel">Floor:</label>
    <select class="filterSelect" (change)="onFilterChange();" [(ngModel)]="filterFloor">
      <option value="">All</option>
      @for (option of floorOptions(); track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </span>
  <span class="filterItem">
    <button matButton="text" (click)="clearFilters()">Clear Filters</button>
  </span>
</div>
@if (readOnly()) {
  <div class="messageWrapper warn">This order is approved and the riser chart is read-only.</div>
}
@if (messages().length > 0) {
  <div class="messageWrapper" [ngClass]="getMessageClass()">
    @for (message of messages(); track message) {
      <div>{{ message }}</div>
    }
  </div>
}
<div class="tableContainer">
  <div id="riserChartTable"></div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
